import { CLEAR_AGENDA_ITEMS } from '../actionTypes'

export const clearAgendaItems = () => ({ type: CLEAR_AGENDA_ITEMS })
